import React from 'react';

import DivHonorPanel from './DivHonorPanel';
import FieldList_CardsPanel from '../../../components/plain/FieldList_CardsPanel';

import {getLanguage} from '../../../util/localStorage';


class DivHonorList extends React.Component {

	/*
		parentField
		path
		readOnly
		plain
		instance
		ignoreTitle
	*/
	constructor(props) {
		super(props);
	}

	honorCardBuilder = (fieldHonor, index) => {
		let card = '';
		
		if(fieldHonor.value.honorInfo.value.length > 0) {
			let currentLanguage = getLanguage();
			let info = null;
			for(let inf of fieldHonor.value.honorInfo.value) {
				if( inf.value.language.value == currentLanguage && inf.value.name.value ) {
					info = inf;
					break;
				}
			}
			if( info == null ) {
				for(let inf of fieldHonor.value.honorInfo.value) {
					if( inf.value.name.value ) {
						info = inf;
						break;
					}
				}
			}			
			if( info )
				card = info.value.name.value
		}
		
		if( ! card ) {
			for(let f of fieldHonor.value.images.value) {
				if( f.value.resourceName.value ) {
					card = f.value.resourceName.value;
					break;
				}
			}
		}
		
		return card;
	}

	render() {
		let path = this.props.path;
		let readOnly = this.props.readOnly;
		let plain = this.props.plain;
		let instance = this.props.instance;
		let parentField = this.props.parentField;
		let ignoreTitle = this.props.ignoreTitle;
		if( ! parentField ) {
			parentField = instance.rootField;
		}
		return (
			<div style={{padding: '10px' }}>
				<FieldList_CardsPanel path={path} instance={instance} plain={plain} parentField={parentField} readOnly={readOnly}
					itemComponent={DivHonorPanel} itemCardBuilder={this.honorCardBuilder}
					ignoreTitle={ignoreTitle} labelEmptyToHeader={true} disableMoveItems={true}
					styles={{
						divCardsBlock: {
							marginRight: '10px',
							backgroundColor: 'rgb(240,240,240)',
							minWidth: '170px',
							maxWidth: '170px'
						},
						divCard: {
							marginTop: '3px',
							padding: '7px',
							cursor: 'pointer',
							backgroundColor: 'lightGray',
							minHeight: '18px'
						}
					}}
				/>
			</div>
		);
	}
}

export default DivHonorList;
